<template>
  <section class="list">
    <component
      :is="component"
      key="infiniteCellList"
      :cell-list="cellList"
      :thumbnail-info="thumbnailInfo"
      :container-class-name="containerClassName"
      :content-info="contentInfo"
      :loading="loading"
      @cell-click-log="sendCellClickLog"
    />
    <div ref="scrollMonitor"></div>
  </section>
</template>
<script>
import CellList from '@/components/section/template/cell/CellList'
import InstantPlayCell from '@/components/section/template/cell/CellListInstantPlay'
import { sendEventLogSearchListCell, sendEventLogSearchEditorPickCell } from '@/common/util/log.v2.send'
import scrollMonitor from 'scrollmonitor'

export default {
  name: 'InfiniteScrollCellList',
  props: ['cellList', 'thumbnailInfo', 'containerClassName', 'contentInfo', 'loading'],
  components: { CellList, InstantPlayCell },
  data () {
    return {
      component: null
    }
  },
  methods: {
    loadMore () {
      this.$emit('load-more')
    },
    sendCellClickLog ({ cellInfo = {}, index = -1, routeName = '' }) {
      this.$route.query.searchCategory === 'theme-list'
        ? sendEventLogSearchEditorPickCell({ cellInfo: cellInfo, index: index, route: this.$route })
        : sendEventLogSearchListCell({ cellInfo: cellInfo, index: index, routeName: routeName })
    }
  },
  mounted () {
    const monitorEl = this.$refs['scrollMonitor']
    this.watcher = scrollMonitor.create(monitorEl, 300)
    this.watcher.enterViewport(this.loadMore)
  },
  created () {
    this.component = this.thumbnailInfo.cellType === 'band_82' ? 'instant-play-cell' : 'cell-list'
  }
}
</script>
